<footer id="bottom" class="text-center text-muted" *ngIf="isHtmlContent != 0">
  <hr>
  <div [innerHTML]="htmlContent"></div>

  <!-- <h6 class="changelog">
    <a href="/changelog" target="_blank" rel="noopener">
      {{ "FOOTER.VERSION" | translate }}
      {{ appVersion }}
    </a>
  </h6> -->
</footer>